import { useCallback, useEffect, useRef, useState } from 'react';
import Output from './CMSMarkdownEditor/Output';
import Input from './CMSMarkdownEditor/Input';
import classes from './CMSMarkdownEditor.module.scss';

const CMSMarkdownEditor = props => {
	const textAreaRef = useRef();
	const [md, setMd] = useState(props.value);
	const [cursorIndices, setCursorIndices] = useState([0, 0]);
	const [ignoreChange, setIgnoreChange] = useState(true);

	useEffect(() => {
		setIgnoreChange(false);
	}, []);

	useEffect(() => {
		if (ignoreChange === false) {
			props.onChange(md, props.fieldID);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [md]);

	useEffect(() => {
		setMd(props.value);
	}, [props.value]);

	const onChangeHandler = value => {
		setMd(value);
	};

	const onCursorChange = index => {
		setCursorIndices([index + 1, index + 1]);
	};

	const onClickHandler = useCallback(
		buttonType => {
			if (md !== null && md !== undefined) {
				const { templatePrefix, templateText, templateSuffix } =
					getTemplate(buttonType);
				const template = `${templatePrefix}${templateText}${templateSuffix}`;

				let newMd =
					md.slice(0, cursorIndices[0]) +
					template +
					md.slice(cursorIndices[1]);
				setMd(newMd);

				setCursorIndices(prev => {
					const start = prev[0] + templatePrefix.length;
					const end = start + templateText.length;
					return [start, end];
				});
			}
		},
		[md, cursorIndices]
	);

	useEffect(() => {
		if (cursorIndices[0] !== cursorIndices[1]) {
			textAreaRef.current.focus();
			textAreaRef.current.selectionStart = cursorIndices[0];
			textAreaRef.current.selectionEnd = cursorIndices[1];
		}
	}, [cursorIndices]);

	const getTemplate = templateType => {
		switch (templateType.toLowerCase()) {
			case 'b':
				return {
					templatePrefix: '**',
					templateText: 'INSERT_BOLD_HERE',
					templateSuffix: '**',
				};
			case 'i':
				return {
					templatePrefix: '_',
					templateText: 'INSERT_ITALICS_HERE',
					templateSuffix: '_',
				};
			case 'code':
				return {
					templatePrefix: '`',
					templateText: 'INSERT_CODE_HERE',
					templateSuffix: '`',
				};
			case 'h1':
				return {
					templatePrefix: '# ',
					templateText: 'INSERT_HEADLINE_HERE',
					templateSuffix: '',
				};
			case 'h2':
				return {
					templatePrefix: '## ',
					templateText: 'INSERT_HEADLINE_HERE',
					templateSuffix: '',
				};
			case 'h3':
				return {
					templatePrefix: '### ',
					templateText: 'INSERT_HEADLINE_HERE',
					templateSuffix: '',
				};
			case 'li':
				return {
					templatePrefix: '\n- ',
					templateText: 'INSERT_LIST_ITEM_HERE',
					templateSuffix: '',
				};
			case 'link':
				return {
					templatePrefix: '[',
					templateText: 'INSERT_LINK_TEXT_HERE',
					templateSuffix: '](INSERT_LINK_URI_HERE)',
				};
			default:
				break;
		}
	};

	return (
		<div className={classes['editor__container']}>
			<Input
				onChangeHandler={onChangeHandler}
				onCursorChange={onCursorChange}
				inputRef={textAreaRef}
				value={md}
				onClickHandler={onClickHandler}
				disabled={props.disabled}
				id={props.id}
			/>
			<Output md={md} />
		</div>
	);
};

export default CMSMarkdownEditor;
